import { Component, ComponentFactoryResolver, EventEmitter, Input, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { SessionService } from 'src/app/services/session/session.service';
import { ChatbaseComponent } from '../chatbase/chatbase.component';
import { CompanyService } from 'src/app/services/company/company.service';
import { TrialWarningDialogComponent } from '../trial-warning-dialog/trial-warning-dialog/trial-warning-dialog.component';
import { AppConfigService } from 'src/app/services/app-config/app-config.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;

  @Output() clickMenuButton: EventEmitter<any> = new EventEmitter<any>();
  @Input() showCloseButton: boolean = false;
  @Input() isDesktop: boolean = false;
  isLogged = this.sessionService.isLogged
  nameUser = this.sessionService.getDetails().fullName
  // get isLogged(): boolean {
  //   return this.sessionService.isLogged;
  // }
  // get nameUser(): string {
  //   return this.sessionService.getDetails().fullName
  // }
  private dialogRef: MatDialogRef<any> | undefined = undefined;
  trialDaysLeft: number | null = null;
  trialDateEnds: string | null = null;
  statusId: number | null = null;
  logoUrl: string;
  appName: string;

  constructor(
    private sessionService: SessionService,
    private dialog: MatDialog,
    private companyService: CompanyService,
    private appConfig: AppConfigService
  ) {
    this.logoUrl = this.appConfig.logoUrl;
    this.appName = this.appConfig.appName;
  }

  clickedMenu() {
    this.clickMenuButton.emit();
  }

  async ngOnInit() {
    if (this.isLogged) {
      const companyId = this.sessionService.getDetails().idCompany;
      try {
        const data = await this.companyService.getCompanyTrialAndStatus(companyId);
        this.statusId = data.statusId;

        if (data.trialPeriodEnd != null) {
          const trialEnd = new Date(data.trialPeriodEnd);
          const now = new Date();
          const diffMs = trialEnd.getTime() - now.getTime();
          const diffHours = diffMs / (1000 * 60 * 60);

          if (diffHours < 24 && diffHours > 0) {
            const day = trialEnd.getDate().toString().padStart(2, '0');
            const month = (trialEnd.getMonth() + 1).toString().padStart(2, '0');
            const hours = trialEnd.getHours().toString().padStart(2, '0');
            const minutes = trialEnd.getMinutes().toString().padStart(2, '0');
            this.trialDateEnds = `${day}/${month} ${hours}:${minutes}`;
          } else {
            const day = trialEnd.getDate().toString().padStart(2, '0');
            const month = (trialEnd.getMonth() + 1).toString().padStart(2, '0');
            this.trialDateEnds = `${day}/${month}`;
          }

          if (this.statusId === 1) {
            const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
            this.trialDaysLeft = diffDays >= 0 ? diffDays : 0;
          }
        }
      } catch (e) {
        //logar sentry
      }
    }
  }

  onClickTrialPeriod() {
    if (this.dialogRef?.getState() === MatDialogState.OPEN) return;

    const isMobile = window.innerWidth <= 600;

    this.dialogRef = this.dialog.open(TrialWarningDialogComponent, {
      width: isMobile ? '95vw' : '600px',
      maxWidth: '95vw',
      panelClass: 'trial-dialog-panel',
      autoFocus: false,
      data: {
        statusId: this.statusId,
        trialDaysLeft: this.trialDaysLeft
      }
    });
  }


  clickedAssistant() {
    if (this.dialogRef?.getState() == MatDialogState.OPEN)
      return;

    this.dialogRef = this.dialog.open(this.dialogTemplate, <MatDialogConfig>{
      hasBackdrop: true,
      disableClose: false,
      height: "100%",
      width: "500px",
      panelClass: "chatbase-dialog",
      position: { right: "0px" },
    });
  }
}
